import createCache, { EmotionCache } from '@emotion/cache';

export const createEmotionCache = (nonce?: string): EmotionCache => {
    return createCache({
        key: 'css',
        nonce: nonce,
        prepend: true,
        speedy: true, // This enables optimized style injection
    });
};
